import { render, staticRenderFns } from "./ComponentShippingCard.vue?vue&type=template&id=57567544&"
import script from "./ComponentShippingCard.vue?vue&type=script&lang=js&"
export * from "./ComponentShippingCard.vue?vue&type=script&lang=js&"
import style0 from "./ComponentShippingCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports